import type { StoreAPI } from "store2";
import store from "store2";

let irStore: StoreAPI | undefined;

export const getIrStore = (): StoreAPI => {
    if (!irStore) {
        irStore = store.namespace("ir");
    }
    return irStore;
};
